export default function Header() {
    return(
        <h1>This . is . Jeopardy!</h1>
    )
};